<template>
    <form class="section-hom-form form-horizontal" @submit.prevent="handleSubmit">
        <!-- Card 1 -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Pregunta frecuente 1</h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Pregunta</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card1.question">
                        <div class="help-block error-message" v-for="e in errors.card1.question" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="tramite1" class="col-sm-2 control-label">URL</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="tramite1" v-model="card1.url">
                        <div class="help-block error-message" v-for="e in errors.card1.url" :key="e">{{ e }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 2 -->
        <div class="panel panel-default">
            <div class="panel-heading ph2">
                <h3 class="panel-title">Pregunta frecuente 2</h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Pregunta</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card2.question">
                        <div class="help-block error-message" v-for="e in errors.card2.question" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="tramite2" class="col-sm-2 control-label">URL</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="tramite2" v-model="card2.url">
                        <div class="help-block error-message" v-for="e in errors.card2.url" :key="e">{{ e }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Card 3 -->
        <div class="panel panel-default">
            <div class="panel-heading ph1">
                <h3 class="panel-title">Pregunta frecuente 3</h3>
            </div>
            <div class="panel-body">
                <div class="form-group">
                    <label for="nombre_link1" class="col-sm-2 control-label">Pregunta</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="nombre_link1" v-model="card3.question">
                        <div class="help-block error-message" v-for="e in errors.card3.question" :key="e">{{ e }}</div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="tramite3" class="col-sm-2 control-label">URL</label>
                    <div class="col-sm-10">
                        <input type="text" class="form-control" id="tramite3" v-model="card3.url">
                        <div class="help-block error-message" v-for="e in errors.card3.url" :key="e">{{ e }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="alert alert-danger text-center" role="alert" v-if="serverError">
            <p>{{ serverErrorMessage }}</p> 
            <p> Por favor, revise los datos ingresados y vuelva a intentar. Si el problema
            persiste, no dude en contactar a nuestro equipo de soporte.</p>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-admin-page-contents/home">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        inputs: {
            type: Array,
            required: true
        },
        
    },
    mounted() {
        // Repoblar datos si existen en `inputs`
        this.populateCards();
    },
    data() {
        return {
            card1: {
                question: '',
                url: null,
            },  
            card2: {
                question: '',
                url: null,
            },
            card3: {
                question: '',
                url: null,
            },
            errors: {
                card1: {
                    question: [],
                    url: [],
                },
                card2: {
                    question: [],
                    url: [],
                },
                card3: {
                    question: [],
                    url: [],
                },
            },
            serverError: false,
            serverErrorMessage: '',
        };
    },
   
    methods: {
        populateCards() {
            this.inputs.forEach((input, index) => {
                if (index === 0 && input && input.question && input.url) {
                    this.card1.question = input.question;
                    this.card1.url = input.url;
                } else if (index === 1 && input && input.question && input.url) {
                    this.card2.question = input.question;
                    this.card2.url = input.url;
                } else if (index === 2 && input && input.question && input.url) {
                    this.card3.question = input.question;
                    this.card3.url = input.url;
                }
            });
        },
        handleSubmit() {
            this.validateForm();

            if (this.hasErrors()) {
                return;
            }

            const cards = [this.card1, this.card2, this.card3];
            axios.put('/backend/new-home/preguntas-frecuentes/edit', { cards })
                .then(response => {
                    window.location.replace(response.data.redirect);
                    // Puedes mostrar un mensaje de éxito o redirigir al usuario
                })
                .catch(error => {
                    this.serverError = true;
                    this.serverErrorMessage = error.response.data.message || 'Ha ocurrido un problema al procesar su solicitud.';
                });
        },
        hasErrors() {
            return Object.values(this.errors).some(cardErrors =>
                cardErrors.question.length > 0 || cardErrors.url.length > 0
            );
        },
        validateForm() {
            this.errors.card1 = this.validateCard(this.card1);
            this.errors.card2 = this.validateCard(this.card2);
            this.errors.card3 = this.validateCard(this.card3);
        },
        validateCard(card) {
            const errors = {
                question: [],
                url: [],
            };
            if (!card.question || card.question.trim() === '') {
                errors.question.push('Campo pregunta es requerido.');
            }
            if (!card.url || card.url.trim() === '') {
                errors.url.push('Campo URL es requerido.');
            } else if (!this.isValidUrl(card.url)) {
                errors.url.push('La URL ingresada no es válida.');
            }

            return errors;
        },
        isValidUrl(url) {
            const expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gi;
            const regex = new RegExp(expression);
            return regex.test(url);
        },
    }
};
</script>

<style scoped>
    .el-select {
        display: block;
    }
    .ph1 {
        background-color: white;
    }
    .error-message {
        color: red;
    }
    .body-grey{
        background-color: #f6f6f6;
    }
    /*** */
    .card {
        border: 1px solid #e3f1f9;
        padding: 16px;
        transition: border-color 0.3s;
        border-radius: 3px;
        display: flex;
        min-height: 60px;
        text-align: left !important;
        margin-bottom: 10px;
    }

    .card:hover {
        border-color: #296290;
        text-decoration: none !important;
    }

    .card p {
        font-family: 'Roboto Serif', serif;
        font-weight: bold;
        color: #0d4d82;
        width: 400px; /* Ajustado el ancho a 450px */
        text-decoration: underline;
        height: 100%;
        transition: text-decoration 0.3s;
    }

    .card:hover p {
        text-decoration: none;
    }

    .card h5 {
        font-size: 16px;
        line-height: 1.6;
        /* Limitar el ancho del texto */
        max-width: 80%;
        white-space: normal;
        overflow-wrap: break-word; 
        word-wrap: break-word;
        word-break: break-word;
        hyphens: auto;
    }

    .has-gob-title {
        background-image: url("../../images/azul-rojo.svg");
        background-repeat: no-repeat;
        background-size: 92px 10px;
        padding-top: 20px;
        display: block;
        font-size: 33px;
    }

    .has-text-dark {
        color: #363636 !important;
    }

    .has-text-weight-bold {
        font-weight: 700 !important;
    }

    .is-underlined {
        text-decoration: underline;
    }

    .has-font-serif {
        font-family: "Roboto Slab", "Times New Roman", serif !important;
    }

    .has-text-primary {
        color: #0f69b4 !important;
        margin-right: 20px !important;
        font-size: 16px !important;
    }
    h2{
        margin-left: 10px;
        margin-bottom: 15px;
    }
</style>